var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"value":_vm.isLoading,"z-index":"250","opacity":_vm.opacity}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":_vm.spinnerSize,"color":_vm.spinnerColor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }